module.exports = __webpack_public_path__ + "img/b_1.be06a79c.png";